import { render, staticRenderFns } from "./edit-purchase-file.html?vue&type=template&id=37cc3200&scoped=true&external"
import script from "./edit-purchase-file.js?vue&type=script&lang=js&external"
export * from "./edit-purchase-file.js?vue&type=script&lang=js&external"
import style0 from "./edit-purchase-file.scss?vue&type=style&index=0&id=37cc3200&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc3200",
  null
  
)

export default component.exports